import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import * as actions from "../../store/actions/actions";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianErrorTranslations from "../../translations/error/it.error.json";
import englishErrorTranslations from "../../translations/error/en.error.json";

class Error extends PureComponent {
  // constructor(props) {
  //   super(props);
  //   this.state = { error: null, errorInfo: null };
  // }
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianErrorTranslations, "it");
    this.props.addTranslationForLanguage(englishErrorTranslations, "en");
  }

  toggle = () => {
    this.props.toggleModal()
  }

  expireSession=()=>{
    this.props.expireSession();
  }

  render() {

    let errors="";
    errors=this.props.error;
    let type="";
    let header = "";
    type=this.props.type;
    let modalError=""
    // let sessionExpiryButton=""
    if(this.props.hasError){
      if(type === "CLIENT"){

        header=<Translate id="error.client.error"/>
        if(errors !== undefined && errors.error !== undefined && errors.error.message !== undefined){
          modalError=errors.error.message
        }else{
          modalError="Network Error"
        }
        // }
      }else if(type === "SERVER"){
        if(errors !== null && errors !== "" && errors !== undefined){
          if(errors.error !== undefined && errors.error.status !== undefined) {
            if (errors.error.status === 500) {
              header = <Translate id="error.server.error" data={{errorStatus: errors.error.status}}/>;
              modalError = <Translate id="error.server.error.text" data={{ errorText: errors.error.data.error}}/>
            }
            if (errors.error.status === 404) {
              header = <Translate id="error.server.error" data={{errorStatus: errors.error.status}}/>
              modalError = <Translate id="error.server.error.text" data={{errorText: errors.error.statusText}}/>
            }
            if (errors.error.status === 405) {
              header = <Translate id="error.server.error" data={{errorStatus: errors.error.status}}/>
              modalError = <Translate id="error.server.error.text" data={{errorText: errors.error.data.error}}/>
            }
            if(errors.error.status === 400){
              header=<Translate id="error.server.error" data={{ errorStatus : errors.error.status }}/>
              modalError=<Translate id="error.server.error.data.validation"/>
            }
            if(errors.error.status === 403){
              header=<Translate id="error.server.error" data={{ errorStatus : errors.error.status }}/>
              modalError=<Translate id="error.server.error.session.expiry"/>
              this.expireSession();
            }
          }else if(errors.status === 400){
            header=<Translate id="error.server.error" data={{ errorStatus : errors.status }}/>
            modalError=<Translate id="error.server.error.data.validation"/>
          }
        } else {
          header =<Translate id="error.server.error.generic" />
          modalError = <Translate id="error.server.error.generic.text" />
        }
      }
    }


    return (

        <div>
          <Modal isOpen={this.props.isModalOpen} toggle={this.toggle} >
            <ModalHeader toggle={this.toggle}>{header}</ModalHeader>
            <ModalBody>
              {modalError}
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.toggle}>
                <Translate id="error.close.button"/>
              </Button>
            </ModalFooter>
          </Modal>
          {this.props.children}
        </div>
        // <div>
        //   <br />
        //   {this.props.error}
        // </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.error.error,
    isModalOpen:state.error.isModalOpen,
    hasError:state.error.hasError,
    type:state.error.type
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleModal:(hasError) =>dispatch({type:actions.TOGGLE_MODAL}),
    expireSession:() =>dispatch({type:actions.EXPIRE_SESSION}),
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Error));